import React from "react";
import "./footer.scss";
import { MdMailOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import { AiFillInstagram } from "react-icons/ai";
import { AiFillFacebook } from "react-icons/ai";
import Copy from "./Copy";
import RiskDisclaimer from "./RiskDisclaimer";

const Footer = () => {

  return (
    <>
      <div className="__fw" style={{ backgroundColor: "#ffffff1e",marginTop:"1rem" }}>
        <div className="__mw">
          <RiskDisclaimer />
          <div className="footer">
            <div className="foot_left">
              <img src={require("../../img/logo.png")} alt="" />
              <small>Smarter Trades. Powered by AI.</small>
              <span>
                We build intelligent trading technology powered by AI, data
                analytics, and automation—designed to simplify trading and
                deliver smarter, more consistent results.
              </span>
              {/* <div className="social">
                <AiFillInstagram className="ic" />
                <AiFillFacebook className="ic" />
              </div> */}
            </div>
            <div></div>
            <div className="foot_right">
              <h3>
                Smarter Trading <br /> <em> Begins With AI</em>{" "}
              </h3>
              {/* <img src={require("../../img/aws.png")} alt="" />
              <small>Powered by AWS</small> */}
            </div>
          </div>
        </div>
      </div>
      <Copy />
    </>
  );
};

export default Footer;
